// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .img_padding_bottom {\n    padding-bottom: 10px;\n} */\n.form-signin{\n    max-width: 330px;\n    padding: 15px;\n    margin: 0 auto;\n}\n.form-signin .form-signin-heading, .form-signin .checkbox{\n    margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
